export default "__VITE_ASSET__u4mud_Xo__"